module.exports = __webpack_public_path__ + "img/DE04038.6284c5eb.png";